import React from "react"

const CalculatorParameters_v2020_B: React.FC<{
  children: (calculatorParameters: { [id: string]: any }) => any
}> = ({ children }) => {
  const calculatorParameters = {
    bias: -3.58,
    ethnicity: [1, 1.07, 1.26, 0.76, 0.43, 0.9], // Index of the array corresponds to the "value" in "options" in the Structure.tsx against the respective key.
    family_history_of_diabetes: [0, 0.382705],
    past_history_of_gestational_diabetes: [0, 1.58659],
    poor_obstetric_outcome: [0, -0.002919],
    maternal_age: {
      range: [
        {
          min: 25,
          max: 29,
          value: 0.286367,
        },
        {
          min: 30,
          max: 34,
          value: 0.521827,
        },
        {
          min: 35,
          max: 39,
          value: 0.76679,
        },
        {
          min: 40,
          max: Infinity,
          value: 1.060443,
        },
      ],
    },
    pre_pregnancy_BMI: {
      range: [
        {
          min: 20.0,
          max: 24.9,
          value: 0.308782,
        },
        {
          min: 25.0,
          max: 26.9,
          value: 0.631777,
        },
        {
          min: 27.0,
          max: 29.9,
          value: 0.962432,
        },
        {
          min: 30.0,
          max: 34.9,
          value: 1.161647,
        },
        {
          min: 35.0,
          max: Infinity,
          value: 1.744555,
        },
      ],
    },
  }
  return <>{children(calculatorParameters)}</>
}

export default CalculatorParameters_v2020_B
